import { render, staticRenderFns } from "./Game_UserBuyProducts.vue?vue&type=template&id=092ba0fc&scoped=true&"
import script from "./Game_UserBuyProducts.vue?vue&type=script&lang=js&"
export * from "./Game_UserBuyProducts.vue?vue&type=script&lang=js&"
import style0 from "./Game_UserBuyProducts.vue?vue&type=style&index=0&id=092ba0fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092ba0fc",
  null
  
)

export default component.exports